import React, { ReactNode, useCallback, useRef } from 'react';
import styled from 'astroturf/react'

import {
  Modal as ModalBase,
  ModalContent as ModalContentBase,
  ModalButtonGroup,
} from 'js/design_system/Modal';
import { TextButton } from 'js/design_system/TextButton';
import $image_url from 'js/utils/image_url';
import ImpressionWatcher, {
  Props as ImpressionProps,
} from 'js/utils/impressions/ImpressionWatcher';
import { Button } from 'js/design_system/Button';
import { useBreakpoint } from 'js/design_system/hooks/useBreakpoint';
import useScrollLock from 'js/utils/hooks/useScrollLock';

import { Tag, Image, Paper } from 'js/social/shared/types';
import {
  SocialEditor,
  SocialEditorHandle,
} from 'js/social/shared/SocialEditor/SocialEditor';
import _Modal from "CreateSocialItemModal-Modal.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/social/CoreX/CreateSocialItem/CreateSocialItemModal.tsx?styleId=Modal";
import _ModalContent from "CreateSocialItemModal-ModalContent.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/social/CoreX/CreateSocialItem/CreateSocialItemModal.tsx?styleId=ModalContent";
import _CreateItemWrapper from "CreateSocialItemModal-CreateItemWrapper.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/social/CoreX/CreateSocialItem/CreateSocialItemModal.tsx?styleId=CreateItemWrapper";
import _ReplyWrapper from "CreateSocialItemModal-ReplyWrapper.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/social/CoreX/CreateSocialItem/CreateSocialItemModal.tsx?styleId=ReplyWrapper";
import _ReplyThread from "CreateSocialItemModal-ReplyThread.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/social/CoreX/CreateSocialItem/CreateSocialItemModal.tsx?styleId=ReplyThread";
import _ThreadLine from "CreateSocialItemModal-ThreadLine.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/social/CoreX/CreateSocialItem/CreateSocialItemModal.tsx?styleId=ThreadLine";
import _ReplyToContent from "CreateSocialItemModal-ReplyToContent.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/social/CoreX/CreateSocialItem/CreateSocialItemModal.tsx?styleId=ReplyToContent";
import _ProfileWrapper from "CreateSocialItemModal-ProfileWrapper.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/social/CoreX/CreateSocialItem/CreateSocialItemModal.tsx?styleId=ProfileWrapper";
import _EditorWrapper from "CreateSocialItemModal-EditorWrapper.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/social/CoreX/CreateSocialItem/CreateSocialItemModal.tsx?styleId=EditorWrapper";
import _SocialEditorWrapper from "CreateSocialItemModal-SocialEditorWrapper.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/social/CoreX/CreateSocialItem/CreateSocialItemModal.tsx?styleId=SocialEditorWrapper";
import _SocialEditorClass from "CreateSocialItemModal-SocialEditorClass.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/social/CoreX/CreateSocialItem/CreateSocialItemModal.tsx?styleId=SocialEditorClass";
import _ProfileImg from "CreateSocialItemModal-ProfileImg.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/social/CoreX/CreateSocialItem/CreateSocialItemModal.tsx?styleId=ProfileImg";
import _ContextWrapper from "CreateSocialItemModal-ContextWrapper.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/social/CoreX/CreateSocialItem/CreateSocialItemModal.tsx?styleId=ContextWrapper";
import _RemoveWrapper from "CreateSocialItemModal-RemoveWrapper.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/social/CoreX/CreateSocialItem/CreateSocialItemModal.tsx?styleId=RemoveWrapper";
import _RemoveButton from "CreateSocialItemModal-RemoveButton.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/social/CoreX/CreateSocialItem/CreateSocialItemModal.tsx?styleId=RemoveButton";
import _AttachmentsRow from "CreateSocialItemModal-AttachmentsRow.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/social/CoreX/CreateSocialItem/CreateSocialItemModal.tsx?styleId=AttachmentsRow";
import _OverflowImpressionWatcher from "CreateSocialItemModal-OverflowImpressionWatcher.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/social/CoreX/CreateSocialItem/CreateSocialItemModal.tsx?styleId=OverflowImpressionWatcher";


const Modal = /*#__PURE__*/styled(ModalBase, null, {
  displayName: "Modal",
  styles: _Modal
});

const ModalContent = /*#__PURE__*/styled(ModalContentBase, null, {
  displayName: "ModalContent",
  styles: _ModalContent
});

const CreateItemWrapper = /*#__PURE__*/styled("div", null, {
  displayName: "CreateItemWrapper",
  styles: _CreateItemWrapper
});

const ReplyWrapper = /*#__PURE__*/styled("div", null, {
  displayName: "ReplyWrapper",
  styles: _ReplyWrapper
});

const ReplyThread = /*#__PURE__*/styled("div", null, {
  displayName: "ReplyThread",
  styles: _ReplyThread
});

const ThreadLine = /*#__PURE__*/styled("div", null, {
  displayName: "ThreadLine",
  styles: _ThreadLine
});

const ReplyToContent = /*#__PURE__*/styled("div", null, {
  displayName: "ReplyToContent",
  styles: _ReplyToContent
});

const ProfileWrapper = /*#__PURE__*/styled("div", null, {
  displayName: "ProfileWrapper",
  styles: _ProfileWrapper
});

const EditorWrapper = /*#__PURE__*/styled("div", null, {
  displayName: "EditorWrapper",
  styles: _EditorWrapper
});

const SocialEditorWrapper = /*#__PURE__*/styled("div", null, {
  displayName: "SocialEditorWrapper",
  styles: _SocialEditorWrapper
});

const SocialEditorClass = _SocialEditorClass.cls2;

const ProfileImg = /*#__PURE__*/styled("img", null, {
  displayName: "ProfileImg",
  styles: _ProfileImg
});

const ContextWrapper = /*#__PURE__*/styled("div", null, {
  displayName: "ContextWrapper",
  styles: _ContextWrapper
});

const RemoveWrapper = /*#__PURE__*/styled("div", null, {
  displayName: "RemoveWrapper",
  styles: _RemoveWrapper
});

const RemoveButton = /*#__PURE__*/styled(TextButton, null, {
  displayName: "RemoveButton",
  styles: _RemoveButton
});

const AttachmentsRow = /*#__PURE__*/styled("div", null, {
  displayName: "AttachmentsRow",
  styles: _AttachmentsRow
});

const OverflowImpressionWatcher = /*#__PURE__*/styled(ImpressionWatcher, null, {
  displayName: "OverflowImpressionWatcher",
  styles: _OverflowImpressionWatcher
});

function ImageUploader({ disabled }: { disabled: boolean }) {
  return (
    <TextButton inline icon="image" disabled={disabled}>
      Image
    </TextButton>
  );
}

function PaperUploader({ disabled }: { disabled: boolean }) {
  return (
    <TextButton inline icon="description" disabled={disabled}>
      Paper
    </TextButton>
  );
}

type Props = {
  replyTo?: {
    node: ReactNode;
    profileImg: ReactNode;
  };
  contextNode?: ReactNode;
  placeholder?: string;
  submitButtonText: string;
  submitButtonEnabled: boolean;
  currentUserProfileImgUrl?: string;
  currentUserProfileNode: ReactNode;
  allowAttachments: boolean;

  content: string;
  tags: Tag[];
  image?: Image;
  paper?: Paper;

  onClose(): void;
  onSubmit(): void;
  onChange(content: string | undefined, tags: Tag[]): void;

  impressionPropsGen: (clickTarget?: string) => ImpressionProps;
};

export const CreateSocialItemModal = React.forwardRef<HTMLDialogElement, Props>(
  (
    {
      replyTo,
      contextNode,
      placeholder,
      submitButtonText,
      submitButtonEnabled,
      currentUserProfileImgUrl,
      currentUserProfileNode,
      content,
      tags,
      image,
      paper,
      allowAttachments,
      onClose,
      onSubmit,
      onChange,
      impressionPropsGen,
    },
    ref,
  ) => {
    // The <Modal> component attempts to prevent scrolling when active but this
    // doesn't currently work on the LISWP so we'll prevent it ourselves.
    useScrollLock();

    const socialEditorRef = useRef<SocialEditorHandle>(null);

    const handleEditorChange = useCallback(
      ({ content, tags }: { content: string; tags: Tag[] }) => {
        onChange(content, tags);
      },
      [onChange],
    );

    const focusEditor = useCallback(() => {
      // The interaction of the <dialog> in the <Modal> component doesn't work
      // well with the initial focus() call inside the <SocialEditor>. To get
      // around this, we manually trigger a focus after the modal animation
      // ends.
      if (socialEditorRef.current) {
        socialEditorRef.current.focus();
      }
    }, [socialEditorRef]);

    const handleRemoveAttachment = useCallback(() => {
      // TODO
    }, []);

    const canAttach = allowAttachments && !image && !paper;

    const blankProfileImg = $image_url('s65_no_pic.gif');

    const breakpoint = useBreakpoint();

    return (
      <Modal
        ref={ref}
        open={true}
        onClose={onClose}
        onAnimationEnd={focusEditor}
      >
        <ModalContent>
          <OverflowImpressionWatcher {...impressionPropsGen()}>
            <CreateItemWrapper>
              {replyTo && (
                <ReplyWrapper>
                  <ReplyThread>
                    {replyTo.profileImg}
                    <ThreadLine />
                  </ReplyThread>
                  <ReplyToContent>{replyTo.node}</ReplyToContent>
                </ReplyWrapper>
              )}
              {!replyTo && (
                <ProfileWrapper>
                  <ProfileImg
                    src={currentUserProfileImgUrl || blankProfileImg}
                  />
                  {currentUserProfileNode}
                </ProfileWrapper>
              )}
              <EditorWrapper>
                {replyTo && (
                  <ProfileImg
                    src={currentUserProfileImgUrl || blankProfileImg}
                  />
                )}
                <SocialEditorWrapper center={!!replyTo}>
                  <SocialEditor
                    ref={socialEditorRef}
                    content={content}
                    tags={tags}
                    placeholder={placeholder}
                    disableTags={false}
                    disableHashtags={false}
                    onChange={handleEditorChange}
                    onSubmit={onSubmit}
                    containerClassName={SocialEditorClass}
                  />
                </SocialEditorWrapper>
              </EditorWrapper>
              {/* TODO: add warning for an attached paper or image without any associated text */}
              {contextNode && (
                <ImpressionWatcher {...impressionPropsGen('attachment')}>
                  <ContextWrapper>
                    <RemoveWrapper>
                      <RemoveButton
                        inverse
                        inline
                        icon="close"
                        onClick={handleRemoveAttachment}
                      >
                        Remove
                      </RemoveButton>
                    </RemoveWrapper>
                    {contextNode}
                  </ContextWrapper>
                </ImpressionWatcher>
              )}
              {allowAttachments && (
                <AttachmentsRow>
                  {/* TODO: Actually allow uploading images and papers */}
                  <ImageUploader disabled={!canAttach} />
                  <PaperUploader disabled={!canAttach} />
                </AttachmentsRow>
              )}
            </CreateItemWrapper>
          </OverflowImpressionWatcher>
          <ModalButtonGroup size={breakpoint === 'small' ? 'small' : 'default'}>
            <ImpressionWatcher {...impressionPropsGen('cancel-button')}>
              <TextButton onClick={onClose} style={{ color: '#4A4A4A' }}>
                Cancel
              </TextButton>
            </ImpressionWatcher>
            <ImpressionWatcher {...impressionPropsGen('post-button')}>
              <Button onClick={onSubmit} disabled={!submitButtonEnabled}>
                {submitButtonText}
              </Button>
            </ImpressionWatcher>
          </ModalButtonGroup>
        </ModalContent>
      </Modal>
    );
  },
);
